export const twistyButtonExpandConversationLabel = "MPb";
export default {twistyButtonExpandConversationLabel};